import { Button, classes, icons } from '@portal/components'
import React from 'react'

const { X } = icons

export type SideBarProps = {
  /**
   * The title of the sidebar
   */
  title: string
  /**
   * The side of the screen the sidebar is on
   */
  side: 'left' | 'right'
  /**
   * Whether the sidebar is open
   */
  open: boolean
  /**
   * Handler for closing the sidebar
   */
  closeHandler?: () => void
  /**
   * Icon to use for closing the sidebar
   */
  closeIcon?: React.ReactNode
  /**
   * The content of the sidebar
   */
  children?: React.ReactNode
}

export default function SideBar({
  title,
  side,
  open,
  closeHandler,
  closeIcon,
  children,
}: SideBarProps) {
  const SideBarHeader = () => (
    <header className="flex h-12 shrink-0 items-center justify-between gap-x-4 border-b border-solid border-border-normal px-4">
      <h3 className="text-base font-medium text-foreground-normal">{title}</h3>

      {closeHandler && (
        <Button
          onClick={() => closeHandler()}
          className="text-foreground-subtle"
          variant="ghost"
          size="square"
          aria-label="Close"
        >
          {closeIcon ? closeIcon : <X className="size-4" aria-hidden="true" />}
        </Button>
      )}
    </header>
  )

  return (
    <div
      className={classes(
        'absolute bottom-0 top-0 z-50 h-full w-48 transform border-solid border-border-normal bg-background transition-transform duration-200 ease-in-out md:w-80',
        side === 'right' ? 'right-0 border-l' : 'left-0 border-r',
        {
          'translate-x-0': open,
          'translate-x-full': !open && side === 'right',
          '-translate-x-full': !open && side === 'left',
        },
      )}
    >
      <div className="flex h-full w-full flex-col">
        <SideBarHeader />
        {children}
      </div>
    </div>
  )
}
